import {Pipe, PipeTransform} from "@angular/core";
import {BusinessI18nService} from "@core/libs";
import {DecimalPipe} from "@angular/common";
import {map, Observable} from "rxjs";
import {castInt} from "@shared/utils";


type DecimalOpts = {
  suffix?: string
}

@Pipe({
  name: 'decimalI18n',
  standalone: false
})
export class DecimalI18nPipe implements PipeTransform {

  constructor(
    private decimalPipe: DecimalPipe,
    private businessI18nService: BusinessI18nService,
  ) {

  }

  transform(value: any, opts?: DecimalOpts): Observable<string | null> {
    return this.businessI18nService.configs$.pipe(
      map(configs => {
        if (!this.isValidNumber(value)) {
          return null;
        }

        let digitsInfo: string | undefined = `1.0-2`;
        // if (opts) {
        // const { minFractionDigits, maxFractionDigits } = opts;
        // digitsInfo = `1.${ minFractionDigits }-${ maxFractionDigits }`;
        // } else if (configs.locale !== 'vi-VN') {
        // // Nếu locale không phải VN cũng không có truyền opts cụ thể thì để auto theo locale
        // digitsInfo = undefined;
        // }
        // if (configs.percentDecimals){
        digitsInfo = `1.0-${castInt(configs.percentDecimals)}`;
        // }
        // digitsInfo = undefined;

        const result = this.decimalPipe.transform(value, digitsInfo, configs.locale);
        const suffix = opts && opts.suffix ? opts.suffix : '';
        return `${result}${suffix}`;
      })
    )
  }

  private isValidNumber(value: any): boolean {
    return typeof value === 'number' && !isNaN(value) ||
      (typeof value === 'string' && !isNaN(parseFloat(value)));
  }
}
